import { FC } from 'react';
import { SkeletonLoader } from '@nextgen-web-framework/all';
import styles from './MePanelContainerShimmer.module.scss';

interface MePanelContainerShimmerPropTypes {
  shimmerCount?: number;
}
const MePanelContainerShimmer: FC<MePanelContainerShimmerPropTypes> = ({ shimmerCount = 5 }) => {
  const renderShimmers = () =>
    Array.from({ length: shimmerCount }, (_, i) => (
      <div key={i} className={styles['skeleton-vertical-gap']}>
        <SkeletonLoader height="48" />
      </div>
    ));

  return <div>{renderShimmers()}</div>;
};

export default MePanelContainerShimmer;
